import React, { useMemo } from 'react';
import { BATCH_DEBIT_HISTORY, MAIN_TAB, ORDER_TYPES, PAYMENT_METHODS, preserveSearchParams, SUB_TAB } from '@icoach/batchPayment/staticData';
import { Link } from 'react-router-dom';
import { mergeQueryToUrl } from '@util/utils';
import { ACCOUNT_BOOK_BULK_DEBIT_URL } from "@icoach/router/routerPath";
import RentCabinetBatchPaymentBatchDebitHistory from './RentCabinetBatchPaymentBatchDebitHistory';
import RentCabinetBatchPaymentCurrentDebitList from './RentCabinetBatchPaymentCurrentDebitList';
import RentCabinetBatchPaymentExemptedDebitList from './RentCabinetBatchPaymentExemptedDebitList';
import RentCabinetBatchPaymentOverdueDebitList from './RentCabinetBatchPaymentOverdueDebitList';
import { BatchPaymentMainTabSwitcher } from "@icoach/batchPayment/component";

const RentCabinetBatchPaymentPage = ({ searchParams, ...rest }) => {

    const tabsConfigs = useMemo(() => {
        return {
            [BATCH_DEBIT_HISTORY]: {
                label: "扣款結果列表",
                value: BATCH_DEBIT_HISTORY,
                to: mergeQueryToUrl(
                    ACCOUNT_BOOK_BULK_DEBIT_URL,
                    preserveSearchParams(searchParams, {
                        [MAIN_TAB]: BATCH_DEBIT_HISTORY
                    })
                ),
                buttonComponent: Link,
                listComponent: <RentCabinetBatchPaymentBatchDebitHistory/>
            },
            [ORDER_TYPES.CURRENT]: {
                label: "扣款名單",
                value: ORDER_TYPES.CURRENT,
                to: mergeQueryToUrl(
                    ACCOUNT_BOOK_BULK_DEBIT_URL,
                    preserveSearchParams(searchParams, {
                        [MAIN_TAB]: ORDER_TYPES.CURRENT,
                        [SUB_TAB]: PAYMENT_METHODS.CREDIT
                    })
                ),
                buttonComponent: Link,
                listComponent: <RentCabinetBatchPaymentCurrentDebitList />
            },
            [ORDER_TYPES.EXEMPTED]: {
                label: "免扣款名單",
                value: ORDER_TYPES.EXEMPTED,
                to: mergeQueryToUrl(
                    ACCOUNT_BOOK_BULK_DEBIT_URL,
                    preserveSearchParams(searchParams, {
                        [MAIN_TAB]: ORDER_TYPES.EXEMPTED
                    })
                ),
                buttonComponent: Link,
                listComponent: <RentCabinetBatchPaymentExemptedDebitList />,
            },
            [ORDER_TYPES.OVERDUE]: {
                label: "未扣款名單",
                value: ORDER_TYPES.OVERDUE,
                to: mergeQueryToUrl(
                    ACCOUNT_BOOK_BULK_DEBIT_URL,
                    preserveSearchParams(searchParams, {
                        [MAIN_TAB]: ORDER_TYPES.OVERDUE,
                        [SUB_TAB]: PAYMENT_METHODS.CREDIT
                    })
                ),
                buttonComponent: Link,
                listComponent: <RentCabinetBatchPaymentOverdueDebitList />,
            }
        };
    },
        // eslint-disable-next-line
        [searchParams]);
    const activeTab = searchParams[MAIN_TAB] || BATCH_DEBIT_HISTORY;

    return <BatchPaymentMainTabSwitcher sourceData={tabsConfigs} activeTab={activeTab} {...rest} />;
};

export default RentCabinetBatchPaymentPage;
